/**
 * login operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {loginSuccessAction, logoutAction} from "../redux/authorization/actions";
import {
    REST_CALL_LOGIN,
    REST_CALL_VERIFY,
    REST_SERVER_BASE_URL
} from "../config";
import {loadConfiguration, loadUserSettings} from "./configuration";
import {loadMenu} from "./menu";
import {loadTypeDefinitions} from "./types";
import {showInitialFilter} from "./listing";
import {showError} from "./message";
import {fetchJSONActivity} from "./communication";
import {refreshBox} from "./cbox";
import {initBoxAction} from "../redux/cbox/actions";


export function login(user, password) {

    return async (dispatch, getState) => {

        const requestData = {"user": user, "password": password};

        try {
            // perform server communication
            const json = await fetchJSONActivity(dispatch, "logging in",
                REST_SERVER_BASE_URL + REST_CALL_LOGIN.path, {
                    method: REST_CALL_LOGIN.method,
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData)
                }
            );

            // remember token for this session
            if (typeof(Storage) !== "undefined") {
                sessionStorage.setItem('token', json.accessToken);
            }

            // process response
            dispatch(loginSuccessAction(json.accessToken, json.userInfo, json.roleInfo, json.typeInfo));

            await initApplication(dispatch, getState);

            // show some objects after login
            // TODO: show more specific object list
            // TODO: avoid pushStateAction
            await showInitialFilter()(dispatch, getState);
        }
        catch (error) {
            showError(error)(dispatch);
        }

    }
}

export function loginBox(cboxName, screenIndex) {

    return async (dispatch, getState) => {

        const user = "cbox";
        const password = "d5TL55llb0xRfZZMS9rUuVnA";
        const requestData = {"user": user, "password": password};

        try {
            // perform server communication
            const json = await fetchJSONActivity(dispatch, "logging in",
                REST_SERVER_BASE_URL + REST_CALL_LOGIN.path, {
                    method: REST_CALL_LOGIN.method,
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData)
                }
            );

            // do NOT remember token for this session as "cbox"

            // process response
            dispatch(loginSuccessAction(json.accessToken, json.userInfo, json.roleInfo, json.typeInfo));

            // init application
            await loadTypeDefinitions()(dispatch, getState);
            dispatch(initBoxAction(cboxName, screenIndex));
            await refreshBox(cboxName)(dispatch, getState);
        }
        catch (error) {
            showError(error)(dispatch);
        }

    }
}

export function verifyToken(accessToken) {
    return async (dispatch, getState) => {

        console.log("verifying token", accessToken);

        try {
            // perform server communication
            const json = await fetchJSONActivity(dispatch, "authenticating",
                REST_SERVER_BASE_URL + REST_CALL_VERIFY.path, {
                    method: REST_CALL_VERIFY.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + accessToken
                    }
                }
            );

            // process response
            dispatch(loginSuccessAction(accessToken, json.userInfo, json.roleInfo, json.typeInfo));

            // init application
            await initApplication(dispatch, getState);
            return true;
        }
        catch (error) {
            showError(error)(dispatch);
            return false;
        }
    }
}

async function initApplication(dispatch, getState) {
    // init application
    await loadTypeDefinitions()(dispatch, getState);
    await loadConfiguration()(dispatch, getState);
    const userInfo = getState().authorization.userInfo;
    if (userInfo && userInfo.id) {
        await loadUserSettings(userInfo.id, userInfo.name)(dispatch, getState);
    }
    await loadMenu()(dispatch, getState);
}

export function logout() {
    return (dispatch) => {

        // forget token for this session
        if (typeof(Storage) !== "undefined") {
            sessionStorage.removeItem('token');
        }

        dispatch(logoutAction());
    }
}